import React, {useState, useEffect}  from 'react';

//import domtoimage from 'dom-to-image';
//import logo from './logo.svg';

import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, /* Switch, Route */  } from "react-router-dom";

import './Styles/App.css';
import ConstantObject from './Components/Constants';

//import SocialGroup from './Components/SocialGroup';
import SocialOptionsSizes from './Components/SocialOptionsSizes';
import SocialOptionsTextAlign from './Components/SocialOptionsTextAlign';
import ImageList from './Components/ImageList';
import Bachan from './Components/Bachan';

import TheCanvas from './Components/TheCanvas';

/*
import { NavigationBar } from './Components/NavigationBar';
import { About } from './Components/About';
import { Home } from './Components/Home';
import { NoMatch } from './Components/NoMatch';
*/
import Sidebar from './Components/Sidebar';


function App() {

  const defaultSize = {
    width: 300,
    height: 450,
    type: "story",
    title: "Media Post",
    url: "social-5x75.gif"
	};

  const defaultBachan = {title:'Baba Ji Bachan',
  text:'ਗੁਰੂ ਨਾਨਕ ਖਾਲੀ ਘੜੇ ਨੂ ਮਿਲਦਾ ਹੈ ਭਰੇ ਹੋਏ ਨੂ ਨਈ|<br/> \
  ਖਾਲੀ ਹੋ ਜਾਓ <br/> ਜੇ ਗੁਰੂ ਨਾਨਕ ਸਾਹਿਬ ਨੂ ਮਿਲਣਾ ਹੈ |',
  quoted_by: 'ਬਾਬਾ ਨੰਦ ਸਿੰਘ ਜੀ ਮਹਾਰਾਜ'
};

  const textAlignArray = [
      {key: "1", title: 'top', url: 'img-align-t.gif'},
      {key: "2", title: 'center', url: 'img-align-c.gif'},
      {key: "3", title: 'bottom', url: 'img-align-b.gif'},
    ];

  const [imageSizeArray, setImageSizeArray] = useState([]);
  const [imageListArray, setImageListArray] = useState([]);
  const [bachansArray, setBachansArray] = useState([]);

  const [fetchedBachansArray, setFetchedBachansArray] = useState(false);
  const [fetchedSizearray, setFetchedSizearray] = useState(0);
  const [fetchedAlignarray, setFetchedAlignarray] = useState(0);
  const [fetchedImgList, setFetchedImgList] = useState(false);

  const [selectedImgSize, setSelectedImgSize] = useState(defaultSize);
  const [selectedTextAlign, setSelectedTextAlign] = useState({title:'center'});
  const [bachan, setBachan] = useState(defaultBachan);

  const [showImgSizes, setShowImgSizes] = useState(false);
  const [showImgList, setShowImgList] = useState(false);
  const [showTextAlign, setShowTextAlign] = useState(false);
  const [showSelectBachansList, setShowSelectBachansList] = useState(false);

  const [activePath, setActivePath] = useState('aaa');

  const [bgImgUrl, setBgImgUrl] = useState((ConstantObject.quotes_img_root + 'abs-bg-1.jpg'));

  const GetBachans = async () => {
    console.log(ConstantObject.getbachansurl);

    const resp = await fetch(ConstantObject.getbachansurl);
    const data = await resp.json();

    if (parseInt(data.success, 10) === 1) {
      setBachansArray(data.data);
      console.log("got bachans");
      console.log(data.data);
      console.log("setting setFetchedBachans");
      setFetchedBachansArray(true);
      setShowSelectBachansList(true);
    }
  }

  const GetImageListArray = async () => {
    const resp = await fetch(ConstantObject.imagelist_json);
    const data = await resp.json();

    setImageListArray(data.imagelistarray);
    console.log("got imglist data");
    console.log(data.imagelistarray);
    setFetchedImgList(true);
  }

  const GetImageSizeArray = async () => {
    const resp = await fetch(ConstantObject.imagesizes_json);
    const data = await resp.json();

    setImageSizeArray(data.imageSizeArray);
    console.log("got data");
    console.log(data);
    setFetchedSizearray(1);
  }

  const updateBachan = (bachan) => {
    console.log("changing bachan");
    console.log(bachan);

    var text = { text: "", quoted_by : "" };
    if (bachan.content_pa && bachan.content_pa.length > 0) {
      text.text = bachan.content_pa;
      text.quoted_by = bachan.name_pa;
    }
    else if (bachan.content_en && bachan.content_en.length > 0) {
      text.text = bachan.content_en;
      text.quoted_by = bachan.name_en;
    }
    else if (bachan.content_hi && bachan.content_hi.length > 0) {
      text.text = bachan.content_hi;
      text.quoted_by = bachan.name_hi;
    }

    setBachan(text);
    setShowSelectBachansList(false);
  }

  const updateBgImage = (imgUrl) => {
    console.log("changing bg img");
    console.log(imgUrl);
    setBgImgUrl(ConstantObject.quotes_img_root+imgUrl);

    setShowImgList(false);
  }

  const updateImageSize = (imgSize) => {
    console.log("changing img size");
    console.log(imgSize);
    setSelectedImgSize(imgSize);
    setFetchedSizearray(fetchedSizearray + 1);

    setShowImgSizes(false);
  }

  const updateTextAlign = (align) => {
    console.log("changing align");
    console.log(align);
    setSelectedTextAlign(align);
    setFetchedAlignarray(fetchedAlignarray + 1);

    setShowTextAlign(false);
  }

  useEffect(function() {
    if(fetchedBachansArray===false)
    {
      GetBachans()
    }
  }, [fetchedBachansArray])

  useEffect(function() {
    if(fetchedImgList===false)
    {
      GetImageListArray()
    }
  }, [fetchedImgList])

  useEffect(function() {
    if(fetchedSizearray===0)
    {
      GetImageSizeArray()
    }
  }, [fetchedSizearray]);

/*
  const DownloadImage = () => {
    const node = this.mainCanvasRef.current;
    domtoimage.toJpeg(node, { quality: 0.95 })
        .then(function (dataUrl) {
            var link = document.createElement('a');
            link.download = 'my-image-name.jpg';
            link.href = dataUrl;
            link.click();
        });
  }
  */

  const SideBarItemClick = (path) => {
    console.log("app click");
    console.log(path);
    setActivePath(path);

    if (path === "/imgsizes")
      return setShowImgSizes(true);
    if (path === "/imglist")
      return setShowImgList(true);
    if (path === '/textalign') {
      console.log("textalign true");
      setFetchedAlignarray(fetchedAlignarray + 1);
      return setShowTextAlign(true);
    }
    if (path === '/bachans')
      return setShowSelectBachansList(true);
  }

  return (
    <div className="App">

    <React.Fragment>
      <Router>
        <Sidebar onItemClick={SideBarItemClick}/>
      </Router>
    </React.Fragment>

    {( (activePath === '/imgsizes') && showImgSizes && fetchedSizearray) &&
      (<SocialOptionsSizes
      SetImageSize={updateImageSize}
      imageListArray={imageSizeArray}
      />)}
      {( (activePath === '/imglist') && showImgList && fetchedImgList) &&
        (<ImageList
        SetImg={updateBgImage}
        imageListArray={imageListArray}
        />)}
      {( (activePath === '/bachans') && showSelectBachansList && fetchedBachansArray) &&
        (<Bachan
        SetBachan={updateBachan}
        bachansArray={bachansArray}
        />)}
        {( (activePath === '/textalign') && showTextAlign && fetchedAlignarray) &&
          (<SocialOptionsTextAlign
          SetTextAlign={updateTextAlign}
          textAlignArray={textAlignArray}
          />)}

      {(fetchedImgList && fetchedSizearray && fetchedBachansArray) &&
        <TheCanvas
          backgroundImage={bgImgUrl}
          width={selectedImgSize.width}
          height={selectedImgSize.height}
          textalign={selectedTextAlign}
          bachan={{__html:
            ' \
            <div class="bachan">' + bachan.text+'</div> \
            <div class="sggs">'+ "-" + bachan.quoted_by+'</div> \
            '}}
        />}
    </div>
  );
}

export default App;
